<div
    class="container flex flex-col gap-4 overflow-y-auto overscroll-contain"
    [ngClass]="{ 'container-mobile': isMobileSize$ | async, 'small-landscape': (isInLandscapeMode | async) === true }"
    cdkScrollable>
    <ng-container *ngIf="activeTickets$ | async; let activeTickets">
        <div class="flex flex-col items-stretch bg-white p-4 shadow-md dark:bg-black" *ngIf="activeTickets.length > 0">
            <h2
                class="gl-light-dark:uppercase text-sm font-bold text-grey-dark dark:text-contrast-yellow"
                [class.uppercase]="env.TICKET?.UPPERCASE_TITLE ?? false">
                {{ 'ACTIVE_TICKETS' | translate }}
            </h2>
            <rwidget-ticket-card
                *ngFor="let ticket of activeTickets; trackBy: getTicketId"
                [active]="true"
                [ticket]="ticket"
                [favoriteTickets]=""
                (refreshTickets)="handleRefreshTickets()"></rwidget-ticket-card>
        </div>
    </ng-container>
    <ng-container *ngIf="recentlyUsedTickets$ | async; let recentlyUsedTickets">
        <ng-container *ngIf="env.EXPIRED_QR_TICKETS_AVAILABLE">
            <div class="flex flex-col items-stretch bg-white p-4 dark:bg-black" *ngIf="recentlyUsedTickets.length > 0">
                <h2
                    class="gl-light-dark:uppercase text-sm font-bold text-grey-dark dark:text-contrast-yellow"
                    [class.uppercase]="env.TICKET?.UPPERCASE_TITLE ?? false">
                    {{ 'TICKET_USED' | translate }}
                </h2>
                <rwidget-ticket-card
                    *ngFor="let ticket of recentlyUsedTickets; trackBy: getTicketId"
                    [ticket]="ticket"
                    [recentlyUsed]="true"
                    [active]="false"
                    [favoriteTickets]=""
                    (refreshTickets)="handleRefreshTickets()"></rwidget-ticket-card>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="inactiveTickets$ | async; let inactiveTickets">
        <div class="flex flex-col items-stretch bg-white p-4 dark:bg-black" *ngIf="inactiveTickets.length > 0">
            <h2
                class="gl-light-dark:uppercase text-sm font-bold text-grey-dark dark:text-contrast-yellow"
                [class.uppercase]="env.TICKET?.UPPERCASE_TITLE ?? false">
                {{ 'INACTIVE_TICKETS' | translate }}
            </h2>
            <rwidget-ticket-card
                *ngFor="let ticket of inactiveTickets; trackBy: getTicketId"
                [active]="false"
                [ticket]="ticket"
                [favoriteTickets]=""
                (refreshTickets)="handleRefreshTickets()"></rwidget-ticket-card>
        </div>
    </ng-container>

    <p class="text-center" *ngIf="(tickets$ | async)?.length === 0 && (ticketsLoaded$ | async) === true">
        {{ 'DIALOG_NO_TICKETS_AVAILABLE_TITLE' | translate }}
    </p>
    <ng-container *ngIf="env.HIDE_SKELETON_LOADER; else skeleton">
        <ridango-ui-basic-loading-spinner [ngClass]="{ 'invisible md:hidden': (ticketsLoaded$ | async) === true }">
        </ridango-ui-basic-loading-spinner>
    </ng-container>
    <ng-template #skeleton>
        <div class="bg-white dark:bg-contrast-black" *ngIf="(ticketsLoaded$ | async) === false">
            <div class="flex px-2 pt-2">
                <ridango-ui-skeleton-loader class="w-full" height="6rem" count="10"> </ridango-ui-skeleton-loader>
            </div>
        </div>
    </ng-template>
</div>
